(function() {

    angular
        .module('app')
        .directive('ngShare', ngShare);
    	ngShare.$inject = ["$location"];

        	function ngShare($location) {
			    return {
			        restrict: 'E',
			        scope: {
                      espai: "="
                    },
		            templateUrl: 'static/app/views/directive/share.html',
			        link: function ( scope, elem, attrs ) {
			        	
			        	scope.twitterText = "";
			        	var getTwitter = function(arr)
			        	{
			        		for (var i = 0; i < arr.length; i++) {
			        			if(arr[i].provider=="T"){
			        				scope.twitterText = arr[i].title
			        			}
			        		}

			        	}

			        	getTwitter(scope.espai.info.social);
			        	
			            scope.shareUrl = function()
			            {
			            	return window.location.href;
			            };
			        }
			    };
			}


})();
